<template>
  <div>
    <div class="text-xl font-black py-2 mt-8">1. Local Market</div>
    <div class="font-black py-2">Local Market Condition</div>

    <office-land-registry-data v-model="form.attachment" :officeId="review.office_id" :reviewId="review.id" :figure-only="true" />
    <!-- Sub section -->
    <div class="mt-8 pt-2">
      <div class="mb-4">
        <div>Current Market conditions:</div>
        <div v-for="(question, index) in form.questions[page][sectionStart]" :key="index">
          <review-question-component v-model="form.questions[page][sectionStart][index]" :showMandatory="showMandatory"></review-question-component>
          <hr class="border-b my-8" />
        </div>
      </div>
    </div>
    <div class="mt-8 pt-2">
      <div class="font-black text-lg py-2">Top challenges:</div>
      <div v-for="(question2, index2) in form.questions[page][sectionStart+1]" :key="index2">
        <review-question-component v-model="form.questions[page][sectionStart+1][index2]" :showMandatory="showMandatory"></review-question-component>
      </div>
    </div>
  </div>
</template>

<script>
import ReviewQuestionComponent from '@/components/AnnualReview/ReviewQuestionComponent'

export default {
  components: { ReviewQuestionComponent },
  props: ['value', 'review', 'page', 'sectionStart', 'showMandatory'],
  data () {
    return {
      form: this.value
    }
  },
  mounted () {
  }
}
</script>
